module.exports = window["wp"]["components"];